import React from 'react';

// Utils
import PropTypes from 'prop-types';

// Components
import * as S from './Styled';

const propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

const Message = ({ title, text }) => {
  return (
    <S.Message>
      <S.Trian />
      <S.Content>
        {title ? <S.Title>{title}</S.Title> : null}
        {text ? <S.Paragraph>{text}</S.Paragraph> : null}
      </S.Content>
    </S.Message>
  );
};

Message.propTypes = propTypes;

export default Message;
